<template>
  <div id="app">
    <div v-if="isUpToDate">
      <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
      <b-modal :active.sync="activeModal" :canCancel="[]">
        <selectStore :cancelBtn="false"/>
      </b-modal>
      <main>
        <router-view/>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import selectStore from '@/views/selectStore'
import { getCurrentBranchPOS } from '@/utils/helper/localStorage'

export default {
  name: 'app',
  data () {
    return {
      activeModal: false,
      isUpToDate: true
    }
  },
  components: {
    selectStore
  },
  methods: {
    ...mapActions([
      'setSellsukiAuth',
      'initState',
      'fetchStepPricing',
      'setIsloading'
    ]),
    checkVersion () {
      let vm = this
      axios.get('/static/version.txt?t=' + Date.now())
        .then(function (response) {
          let clientScriptVersion = window.sellsukiVersion.trim()
          let serverScriptVersion = response.data.trim()
          if (clientScriptVersion === serverScriptVersion) {
            vm.isUpToDate = true
          } else {
            vm.isUpToDate = false
            vm.$dialog.confirm({
              title: 'CHECK VERSION UPDATE',
              message: 'Your version is behide, Please reload to latest version.',
              onConfirm: () => {
                vm.setSellsukiAuth('')
                window.localStorage.removeItem('currentBranchPOS')
                window.location.href = process.env.SELLSUKI_LOGOUT_PORTAL
              }
            })
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  computed: {
    ...mapGetters({
      sellsukiAuth: 'getSellsukiAuth',
      isLoading: 'getIsLoading'
    })
  },
  async mounted () {
    this.setIsloading(true)
    await this.fetchStepPricing()
    await this.initState()
    if (!this.sellsukiAuth) {
      await this.setSellsukiAuth(this.$sellsuki_auth.getSellsukiData())
    }
    let currentBranchPOS = getCurrentBranchPOS()
    if (!currentBranchPOS) {
      this.activeModal = true
    }
    this.setIsloading(false)
  },
  created () {
    this.checkVersion()
    setInterval(this.checkVersion, 60000)
  }
}
</script>

<style>
p.modal-card-title {
  text-align: center;
  font-size: 1.4rem;
}
button.button.is-primary, button.button.is-primary:hover, button.button.is-primary:focus, button.button.is-primary:active {
  background: black;
}
.modal-card.animation-content footer.modal-card-foot {
  justify-content: center;
}
.success-message {
  font-weight: bold;
  color: #27cf5a;
}
.error-message {
  font-weight: bold;
  color: #f83c3c;
}
* {
  user-select: none;
}
input {
  user-select: text;
}
input.input {
  font-size: 0.9rem;
}
html,
body{
  height: 100%;
  width: 100%;
  margin: 0;
  position: relative;
}

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  /* font-family: 'Tahoma', Geneva, sans-serif; */
  font-family: Tahoma, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/App.vue